import { ClientDebtWarning } from 'src/typings';

export function getClientDebtWarning(source: any): ClientDebtWarning | null {
  const candidates = [
    source?.warning,
    source?.credit_warning,
    source?.error?.warning,
    source?.error?.credit_warning,
    source?.error?.message?.warning,
    source?.error?.response?.warning,
    source?.error?.error?.warning,
    source?.error?.error?.message?.warning,
    source?.generated_docs?.credit_warning,
    source?.error?.generated_docs?.credit_warning
  ];

  const warning = candidates.find((item) => item?.code === 'CLIENT_DEBT_WARNING');
  return warning || null;
}

export function getDebtWarningMessages(source: any): string[] {
  const warning = getClientDebtWarning(source);
  if (warning?.messages?.length) return warning.messages;
  return Array.isArray(source?.warnings) ? source.warnings : [];
}

export function confirmClientDebtWarning(warning: ClientDebtWarning): boolean {
  return window.confirm(formatClientDebtWarning(warning));
}

export function formatClientDebtWarning(warning: ClientDebtWarning): string {
  const lines = [
    ...(warning.messages || []),
    '',
    `Текущий долг: ${formatMoney(warning.current_debt)}`,
    `Сумма отгрузки: ${formatMoney(warning.shipment_amount)}`,
    `Долг после проведения: ${formatMoney(warning.projected_debt)}`
  ];

  if (warning.debt_limit !== null && warning.debt_limit !== undefined) {
    lines.push(`Лимит долга: ${formatMoney(warning.debt_limit)}`);
  }
  if (warning.exceeded_amount > 0) {
    lines.push(`Превышение: ${formatMoney(warning.exceeded_amount)}`);
  }
  if (warning.overdue_debt > 0) {
    lines.push(`Просрочка: ${formatMoney(warning.overdue_debt)}`);
  }
  if (warning.prepayment_balance > 0) {
    lines.push(`Предоплата после проведения: ${formatMoney(warning.prepayment_balance)}`);
  }

  lines.push('', 'Провести документ несмотря на предупреждение?');
  return lines.join('\n');
}

function formatMoney(value: number | null | undefined) {
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(value || 0));
}
